import { FC } from 'react';
import { useFormContext } from 'react-hook-form';

import { Grid } from '@mui/material';

import { NumberInputControlled } from 'components/_basic/Form/NumberInput';

import { concatWithDot } from 'helpers/string';

import { IFormTableRow } from './types';
import { TextInputControl } from '../../../TextInput';
import { FORM_TABLE_COLUMN_NAME, FORM_TABLE_FIRST_COLUMN_NAME } from '../../constants';

import styles from './FormTableRow.module.scss';

export const FormTableRow: FC<IFormTableRow> = ({
  name,
  columns,
  rowIndex,
  disabled,
  firstColumnWidth,
  disabledNameColumn,
  needToConvertToNegative,
  firstColumnLength,
}) => {
  const { control } = useFormContext();

  const parameterFieldName = concatWithDot(name, rowIndex.toString(), FORM_TABLE_FIRST_COLUMN_NAME);

  return (
    <>
      <Grid item sx={{ width: firstColumnWidth }}>
        <TextInputControl
          maxLength={firstColumnLength}
          disabled={disabled || disabledNameColumn}
          name={parameterFieldName}
          id={parameterFieldName}
          control={control}
          className={styles.tableRow}
        />
      </Grid>
      {columns.map((column, index) => {
        const fieldName = concatWithDot(name, rowIndex.toString(), `${FORM_TABLE_COLUMN_NAME}${index}`);
        return (
          <Grid key={column.id} item xs>
            <NumberInputControlled
              disabled={disabled}
              name={fieldName}
              id={fieldName}
              control={control}
              data-mirror-field={name}
              className={styles.tableRow}
              allowNegative={needToConvertToNegative}
            />
          </Grid>
        );
      })}
    </>
  );
};
